import { ReactElement } from 'react';
import { Trans } from 'react-i18next';

import {
   appendTestableElementAttributes,
   DocplannerIcon,
   IconSize,
   IconWrapper,
   PatientPortalIcon,
   StyledFlex,
} from '@dreryk/react-components';
import { dateFormatter, hourMinuteFormatter, Translate } from '@dreryk/react-common';

import { createAppointmentSourceVisitor } from '~libs.shared.appointments';

import { calendarTranslationKeys } from '../../../../../translations';

import { StyledText } from './AppointmentDetailsAppointmentSourceLabelIcon.styled';

const t = calendarTranslationKeys.appointmentContextDialog.tabs.appointmentDetailsTab;

type AppointmentDetailsAppointmentSourceLabelIconProps = {
   sourceLabel: string | undefined;
   creationDate: Date;
};

export const AppointmentDetailsAppointmentSourceLabelIcon = (
   props: AppointmentDetailsAppointmentSourceLabelIconProps
): ReactElement | null => {
   if (!props.sourceLabel) {
      return null;
   }

   const creationDate = dateFormatter(props.creationDate);
   const creationTime = hourMinuteFormatter(props.creationDate);

   return (
      <StyledFlex gap={'4px'} {...appendTestableElementAttributes('appointmentSource')} alignItems={'center'}>
         <IconWrapper testId={'appointmentSource'} size={IconSize.SMALL}>
            {createAppointmentSourceVisitor(props.sourceLabel)({
               visitDocplanner: () => <DocplannerIcon />,
               visitPatientPortal: () => <PatientPortalIcon />,
               visitEgabinet: () => null,
            })}
         </IconWrapper>
         <StyledFlex direction={'column'}>
            {createAppointmentSourceVisitor<ReactElement | null>(props.sourceLabel)({
               visitDocplanner: () => <Translate>{t.appointmentSource.docplanner}</Translate>,
               visitPatientPortal: () => <Translate>{t.appointmentSource.patientPortal}</Translate>,
               visitEgabinet: () => null,
            })}
            <StyledText testId={'creationDate'}>
               <Trans
                  i18nKey={t.creationDateTime}
                  values={{ creationDate: creationDate, creationTime: creationTime }}
               />
            </StyledText>
         </StyledFlex>
      </StyledFlex>
   );
};
